/**
 * Created by: Lior Elrom
 * Date: 6/30/15
 * Time: 3:55 PM
 */

'use strict';

var _ = require('underscore');
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');
var creditCardMixin = require('bunsen/models/mixins/ecomm/creditCardMixin');
var ApplePay = PaymentMethod.extend();

module.exports = ApplePay;

_.extend(ApplePay.prototype, {
    defaults : {
        apiType: 'applePay',
        paymentMethodType: PaymentMethod.TYPE_APPLE_PAY
    },
    getDisplayVal: function () {
        return 'Apple Pay';
    },
    getLastNumbers: function () {
        return this.get('cardLastNumbers');
    },
    getCardType: function () {
        return this.get('cardType');
    }
}, creditCardMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/ApplePay.js
// module id = 181
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54